import * as z from "zod";
export const CumulativeLayoutShift = z.object({
    type: z.literal("cumulative_layout_shift"),
    value: z.object({
        line: z.object({
            /** @example 0.05 */
            value: z.number(),
            /** @example here */
            label: z.string(),
        }),
        needsImprovement: z.object({
            start: z.number(),
            end: z.number(),
        }),
        poor: z.object({
            start: z.number(),
            end: z.number(),
        }),
    }),
});
